export default __webpack_public_path__ + "static/media/person.63748860.svg";